import {
  GET_SUBSCRIPTION,
  GET_SUBSCRIPTION_SUCCESS,
  GET_SUBSCRIPTION_FAILURE,
} from 'store/subscriptionPlan/subscriptionPlanAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const getSubscriptionReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SUBSCRIPTION:
      return { ...state, loading: true };
    case GET_SUBSCRIPTION_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_SUBSCRIPTION_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default getSubscriptionReducer;
